export default class DressageLine {
  constructor(private readonly _direction: string,
              private readonly _command: string) {
  }

  get direction(): string {
    return this._direction;
  }

  get command(): string {
    return this._command;
  }
}
